export default __webpack_public_path__ + "static/media/Empty.5d4a0c07.svg";